module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'oubvef08',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
